<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>实时库存</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.plaSupplyDateId" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :show-pager-on-one-page="false" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button class="align-left" size="small" v-on:click="outExcel"> 导出 </el-button>
          <div class="table-info-display" style="font-weight: 600" v-if="deliveryTakenDate">
            <span>领货日期：</span>
            <span class="alert-text">{{ deliveryTakenDate | formatDate(true) }}</span>
          </div>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column fixed width="120" prop="title" align="center" label="产品名称"> </el-table-column>

        <el-table-column fixed prop="spec" align="center" label="规格"> </el-table-column>

        <el-table-column fixed width="120" prop="ability" align="center" label="基地供应能力"> </el-table-column>

        <el-table-column align="center" v-for="(item, index1) in columnList" :key="index1" :label="item.title">
          <el-table-column width="150" align="center" v-for="(item2, index2) in item.secondTitle" :key="index2" :label="item2">
            <template slot-scope="{ row }">
              <div class="line-height-style" v-for="(tableItem, index3) in row.baseList" :key="index3" :title="tableItem[index1][index2]">
                {{ tableItem[index1][index2] }}
              </div>
              <el-button type="text" v-if="index2 == 1" @click="serach(item.id, row.id)">等级库存实时查询</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog :visible.sync="showInventory" :loading="inventoryLoading" :before-close="closeInventory" width="30%">
      <el-form ref="inventoryForm" :model="listParams" label-width="220px">
        <template v-for="(inventoryItem, ininventoryIndex) in inventoryForm">
          <el-form-item :label="inventoryItem.levelName + ':'">{{ inventoryItem.stock }} <el-button type="text" @click="addInventory(inventoryItem.levelSalesId)"> 追加库存</el-button></el-form-item>
        </template>
      </el-form>
    </el-dialog>
    <el-dialog title="追加库存" width="30%" :visible.sync="innerVisible" append-to-body :modal-append-to-body="false" v-loading="btnLoading">
      <template>
        <el-form inline>
          <div v-for="item in inventoryList">
            <el-form-item label="基地:">
              {{ item.farmName }}
            </el-form-item>
            <el-form-item label="库存:">
              {{ item.currentStock }}
            </el-form-item>
            <el-form-item label="追加库存:">
              <el-input-number v-model="item.appendStock" :min="0" :max="10" label="请输入追加数目"></el-input-number>
            </el-form-item>
          </div>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="btnLoading" :loading="btnLoading" @click="submitInventoryList">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";

export default {
  data() {
    return {
      listParams: {
        plaSupplyDateId: "",
        supplyId: "",
      },
      dateId: "",
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      isDisabled: false,
      columnList: [],
      deliveryBase: "",
      deliveryTakenDate: "",
      dialogTitle: "上菜确认",
      dialogVisible: false,
      itemParams: {
        categoryName: "",
        sort: 1,
      },
      checkItemParams: {
        categoryName: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入序号", trigger: "blur" }],
      },
      inventoryForm: [],
      inventoryLoading: false,
      showInventory: false,
      innerVisible: false,
      inventoryList: [],
      goodId: "",
      siteId: "",
      btnLoading: false,
    };
  },
  mounted() {
    this.listParams.supplyId = parseInt(this.$route.params.supplyId);
    this.loadDateList();
  },
  methods: {
    /**
     * 提交库存
     */
    submitInventoryList() {
      console.log(this.btnLoading);
      if (this.btnLoading) {
        return;
      }
      this.btnLoading = true;
      this.$http({
        url: global.apiUrl + "/supply/appendSalesStockByLevelSalesId",
        method: "POST",
        body: { appendStock: this.inventoryList },
      })
        .then(res => {
          this.innerVisible = false;
          this.showInventory = false;
          this.$message.success(res.body.info);
          this.loadTableData();
          this.btnLoading = false;
        })
        .catch(err => {
          this.innerVisible = false;
          this.btnLoading = false;
          console.error(err);
        });
    },
    /**
     * 追加库存
     */
    addInventory(levelSalesId) {
      this.$http({
        url: global.apiUrl + "/supply/appendSalesStockByLevelSalesId",
        method: "GET",
        params: {
          levelSalesId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              res.body.data.forEach(item => (item.appendStock = 0));
              this.inventoryList = res.body.data;
              this.innerVisible = true;
            } else {
            }
          }
        })
        .catch(err => {
          this.innerVisible = false;
          console.error(err);
        });
    },
    /**
     * 关闭弹窗
     */
    closeInventory() {
      this.showInventory = false;
    },
    /**
     * 库存查询
     */
    serach(siteId, goodId) {
      if (siteId) {
        this.siteId = siteId;
        this.goodId = goodId;
      }
      const params = {
        siteId: this.siteId,
        goodId: this.goodId,
        dataId: this.listParams.plaSupplyDateId,
      };
      this.$http({
        url: global.apiUrl + "/supply/good/levle/realstock",
        method: "GET",
        params: params,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.inventoryForm = res.body.data;
              this.showInventory = true;
              this.inventoryLoading = true;
            } else {
            }
          }
          this.inventoryLoading = false;
        })
        .catch(err => {
          this.inventoryLoading = false;
          console.error(err);
        });
    },
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/supply/goodputsale/supplyDateForRealStock/findAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data;
              if (this.dateList && this.dateList.length > 0) {
                this.listParams.plaSupplyDateId = this.dateList[this.dateList.length - 1].id;
                this.loadTableData();
              }
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/supply/realStock",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              if (res.body.data.dataList) {
                this.tableData = res.body.data.dataList;
              }
              this.columnList = res.body.data.columnList;
              this.dateId = res.body.data.plaSupplyDateId;
              this.deliveryTakenDate = res.body.data.date;
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 导出
     */
    outExcel() {
      const bodyParams = {
        supplyId: this.listParams.supplyId,
        plaSupplyDateId: this.listParams.plaSupplyDateId,
      };

      download("/supply/realStock/export", bodyParams, "实时库存");
      // this.$router.open({
      //   path: "/api/web/supply/realStock/export",
      //   query: bodyParams,
      //   type: "excel",
      // });
    },
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.listParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.listParams[startAttr] = "";
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
